import { Col, Container, Row } from "react-bootstrap";
import "./About.css";
import "../assets/css/style.css";
import "animate.css";
import aboutbg from "../../../pages/Masala-of-india/assets/images/about/vegetales-shapes.png";
import aboutimg from "../../../pages/Masala-of-india/assets/images/about/about-Image.webp";
const CommonHomeAbout = () => {
  return (
    <>
      <section className="about-section about-phn-view" id="about">
        <div className="container-md container-fluid px-0 px-3">
          <div className="row">
            <div className="col-lg-6">
              <div className="content">
                <div className="section-header">
                  <h2 className="wow fadeInUp lh-base">
                    Welcome to Masala of India Cuisine
                  </h2>
                  <h3 className="lh-base">
                    The Best Indian Restaurant in Seattle
                  </h3>
                  <p className="masala-common-content">
                    Masala of India Cuisine is one of the finest Indian
                    Restaurants in Northgate, Seattle, providing the best
                    authentic taste of Indian flavours. Using freshly chosen
                    secret ingredients passed down through generations, the Late
                    Mr. Sanjay Sharma, the owner of Masala Of India Cuisine, has
                    set a new taste standard for Indian food. His fine skills to
                    food lovers with the most palatable, healthiest Indian food
                    and his respect for more than a 100-year-old Indian culinary
                    tradition led him to become one of the featured food vendors
                    at the Northgate Festival. The passion for providing
                    tempting food, along with the concern for the well-being of
                    the consumers, gave birth to the healthiest Indian food
                    cuisine one can find in the whole country.
                  </p>
                  <p className="masala-common-content">
                    Since 2000, our restaurant has been a haven for Indian food
                    lovers, consistently providing mouthwatering dishes that
                    promise to delight your taste buds. Whether you are craving
                    the fiery, sizzling spices of Indian appetisers or looking
                    to indulge in a rich, flavorful curry, our{" "}
                    <a
                      className="text-primary"
                      href="https://www.masalaofindia.com/menu">
                      {" "}
                      Indian Food Menu
                    </a>{" "}
                    has it all.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-6 align-self-center">
              <div className="img">
                <img
                  className="bg-shape"
                  src={aboutbg}
                  alt="masala of india cuisine"
                  loading="lazy"
                />
                <img
                  src={aboutimg}
                  alt="indian food northgate"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CommonHomeAbout;
